import { Button } from '@/components/common/Button';
import { useMainCta } from '@/contexts/mainCta';
import { useHaptics } from '@/hooks/useHaptics';
import { cn } from '@/lib/cn';

/**
 * In-document call-to-action bar. Sits ABOVE the TabBar (between page content
 * and the bottom navigation), inverting Telegram's native MainButton position
 * which appears below the WebView. Routes register their CTA via
 * `useMainButton({ text, enabled, loading, onClick })`.
 */
export function MainCta({
  /**
   * Vero quando sotto NON c'è la barra di navigazione (sottopagine): allora è
   * questa barra l'ultima cosa sullo schermo, e tocca a lei tenersi sopra la
   * barra gesti del sistema. Con la barra di navigazione presente l'inset lo
   * assorbe quella, e ripeterlo qui aprirebbe un vuoto fra le due.
   */
  insetBottom = false,
}: {
  insetBottom?: boolean;
}) {
  const { cta } = useMainCta();
  const haptics = useHaptics();

  if (!cta) return null;

  const disabled = cta.enabled === false || cta.loading === true;

  return (
    <div
      className={cn(
        // `bg-bg` pieno e non `bg-bg/95` col velo sfocato: sopra la texture
        // fissa il velo ne stampava una copia sfocata accanto a una nitida —
        // lo stesso difetto che si vedeva sulla barra di navigazione.
        'border-t border-border bg-bg px-4 pt-2',
        insetBottom
          ? 'pb-[calc(max(env(safe-area-inset-bottom,0px),var(--tg-viewport-safe-area-inset-bottom,0px))+0.5rem)]'
          : 'pb-2',
      )}
    >
      {/* La barra d'azione grande e' `Button size="lg"` (I-353, PR-3); lo spento neutro, anche in caricamento, e'
          del primario (#495): spento e' spento. */}
      <Button
        size="lg"
        fullWidth
        disabled={disabled}
        onClick={() => {
          if (disabled) return;
          haptics.impact('light');
          cta.onClick();
        }}
      >
        {cta.loading ? (
          <span
            aria-hidden
            // In caricamento il bottone e' spento, quindi neutro: lo spinner segue il testo neutro. Con
            // `brand-fg` (teal scuro) su `bg-tertiary` non si vedrebbe.
            className="h-5 w-5 animate-spin rounded-full border-2 border-fg-muted/30 border-t-fg-muted"
          />
        ) : (
          <span>{cta.text}</span>
        )}
      </Button>
    </div>
  );
}
